module.exports = {"532932101":"云鹤镇","532932102":"辛屯镇","532932103":"松桂镇","532932104":"黄坪镇","532932105":"草海镇","532932106":"西邑镇","532932107":"龙开口镇","532932201":"金墩乡","532932203":"六合彝族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532932.json
// module id = 2468
// module chunks = 0